module.exports = __webpack_public_path__ + "static/media/Progress Bars (updated).0240aa8a.jpg";